"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_settings_html_1 = __importDefault(require("./widget-settings.html"));
require("@components/custom-metrics/custom-metrics-modal");
(function (module) {
    'use strict';
    function WidgetSettingsController($injector, $scope, $filter, goService, formatHelper, triggerOverrides, OVERRIDE_EVENTS, colorPaletteService, raterDisplayLogicModal, customMetricsModal) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        var translate = $filter('translate');
        $ctrl.colorPaletteService = colorPaletteService;
        var COLOR = 'COLOR';
        var USE_CHOICE_TOTALS = 'CHOICE_TOTALS';
        var USE_RESPONDENT_TOTALS = 'RESPONDENT_TOTALS';
        var USE_ROW_TOTALS = 'ROW_TOTALS';
        var USE_COLUMN_TOTALS = 'COLUMN_TOTALS';
        function getFormat(options) {
            return {
                FONT: options.FONT.selectedFormat,
                SIZE: options.SIZE.selectedFormat,
                COLOR: options.COLOR.selectedColor,
                BOLD: options.BOLD.selectedFormat
            };
        }
        var RESPONSE_COUNT_VIEW_MODES = $injector.get('widget.productBase.RESPONSE_COUNT_VIEW_MODES');
        var configFlags = triggerOverrides({
            event: OVERRIDE_EVENTS.CONFIG_FLAGS,
            sync: true,
            data: {}
        });
        var enableRaterDisplayLogic = configFlags.shouldHaveRaterDisplayLogic;
        angular.extend($ctrl, {
            $onInit: function () {
                updateChartTextPreviewStyle();
                updateTableHeaderPreviewStyle();
                updateTableBodyPreviewStyle();
            },
            enableRaterDisplayLogic: enableRaterDisplayLogic,
            enableScaleColorPalette: !!configFlags.enableScaleColorPalette,
            widgetPaddingLabel: translate('VISUALIZATION_MARGIN'),
            widgetDensityLabel: translate('TABLE_DENSITY'),
            decimalOptions: _.map([0, 1, 2, 3, 4, 5], function (val) {
                return {
                    label: val + '',
                    value: val
                };
            }),
            responseCountViewModes: _.mapValues(RESPONSE_COUNT_VIEW_MODES, translate),
            shouldShowWeightingOptions: !configFlags.disableWeighting,
            weightingOptions: [{
                    label: translate('ENABLED'),
                    value: true
                },
                {
                    label: translate('DISABLED'),
                    value: false
                }],
            getWeightingOptionsLabel: function () {
                return $ctrl.globalOptions.weighted ? translate('ENABLED') : translate('DISABLED');
            },
            percentageDenominatorOptions: [{
                    label: translate(USE_CHOICE_TOTALS),
                    value: 'choiceTotals'
                },
                {
                    label: translate(USE_RESPONDENT_TOTALS),
                    value: 'respondentTotals'
                }
            ],
            showPercentageOptions: [{
                    label: translate('ENABLED'),
                    value: true
                },
                {
                    label: translate('DISABLED'),
                    value: false
                }
            ],
            rowTotalsOptions: [{
                    label: translate(USE_ROW_TOTALS),
                    value: true
                },
                {
                    label: translate(USE_COLUMN_TOTALS),
                    value: false
                }],
            getPercentageDenominatorLabel: function () {
                return translate($ctrl.globalOptions.percentageDenominator === 'choiceTotals' ?
                    USE_CHOICE_TOTALS : USE_RESPONDENT_TOTALS);
            },
            getRowTotalsLabel: function () {
                return translate($ctrl.globalOptions.useRowTotals ? USE_ROW_TOTALS : USE_COLUMN_TOTALS);
            },
            getShowPercentagesLabel: function () {
                return $ctrl.globalOptions.showPercentages ? translate('ENABLED') : translate('DISABLED');
            },
            metricOptions: {
                choiceCount: translate('CHOICE_COUNT'),
                percentage: translate('PERCENTAGE')
            },
            updateBodyFormat: function (name, value) {
                $ctrl.bodyTextFormatsOptions[name.toUpperCase()].selectedFormat = value;
            },
            updateChartFormat: function (name, value) {
                var formatName = name.toUpperCase();
                if (formatName === COLOR) {
                    $ctrl.chartTextFormatsOptions[formatName].selectedColor = value;
                }
                else {
                    $ctrl.chartTextFormatsOptions[formatName].selectedFormat = value;
                }
                updateChartTextPreviewStyle();
            },
            updateTableHeaderFormat: function (name, value) {
                var formatName = name.toUpperCase();
                if (formatName === COLOR) {
                    $ctrl.tableHeaderTextFormatsOptions[formatName].selectedColor = value;
                }
                else {
                    $ctrl.tableHeaderTextFormatsOptions[formatName].selectedFormat = value;
                }
                updateTableHeaderPreviewStyle();
            },
            updateTableBodyFormat: function (name, value) {
                var formatName = name.toUpperCase();
                if (formatName === COLOR) {
                    $ctrl.tableBodyTextFormatsOptions[formatName].selectedColor = value;
                }
                else {
                    $ctrl.tableBodyTextFormatsOptions[formatName].selectedFormat = value;
                }
                updateTableBodyPreviewStyle();
            },
            getTextPreviewStyle: function () {
                return formatHelper.getStyles(getFormat($ctrl.bodyTextFormatsOptions));
            },
            getDisplayLogicLabel: function () {
                return translate('PR.HIDE_VISUALIZATIONS_NOTE', { responseThreshold: $ctrl.globalOptions.displayLogic.responseThreshold });
            },
            openRaterDisplayLogicModal: function () {
                raterDisplayLogicModal.show();
            },
            openCustomMetricsModal: function () {
                customMetricsModal.show();
            },
            getCharacterLimitNote: function () {
                return translate('PR.CHARACTER_LIMIT.NOTE', {
                    limit: $ctrl.globalOptions.resultsTableCharacterLimit.value
                });
            }
        });
        function updateChartTextPreviewStyle() {
            var format = getFormat($ctrl.chartTextFormatsOptions);
            goService.applyChartTextStyles('.preview-widget-body', format, 'pr-chart-styles-preview');
        }
        function updateTableHeaderPreviewStyle() {
            var format = getFormat($ctrl.tableHeaderTextFormatsOptions);
            goService.applyTableHeaderTextStyles('.preview-table-body', format, 'pr-table-header-preview');
        }
        function updateTableBodyPreviewStyle() {
            var format = getFormat($ctrl.tableBodyTextFormatsOptions);
            goService.applyTableBodyTextStyles('.preview-table-body', format, 'pr-table-body-preview');
        }
    }
    WidgetSettingsController.$inject = [
        '$injector',
        '$scope',
        '$filter',
        'pr.globalOptionsService',
        'prTextFormatsHelper',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'widget.componentBase.colorPaletteService',
        'prRaterDisplayLogicModal',
        'pr.customMetricsModal'
    ];
    module.component('prWidgetSettings', {
        templateUrl: widget_settings_html_1.default,
        controller: WidgetSettingsController,
        bindings: {
            globalOptions: '=',
            bodyTextFormatsOptions: '=',
            tableHeaderTextFormatsOptions: '=',
            tableBodyTextFormatsOptions: '=',
            chartTextFormatsOptions: '=',
            selectWidgetTab: '<'
        }
    });
})(angular.module('qualtrics.pr'));
